;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');

	Collection.States = Backbone.Collection.extend({
		model: Model.State,

		initialize: function(){
			this.add([
        {
					id: '',
					state: 'Pick your state'
				},
				{
					id: 'ACT',
					state: 'Australian Capital Territory'
				},
				{
					id: 'NT',
					state:'Northern Territory'
				},
				{
					id: 'NSW',
					state: 'New South Wales'
				},
				{
					id: 'VIC',
					state: 'Victoria'
				},
				{
					id: 'SA',
					state: 'South Australia'
				},
				{
					id: 'WA',
					state: 'Western Australia'
				},
				{
					id: 'TAS',
					state: 'Tasmania'
				},
				{
					id: 'QLD',
					state: 'Queensland'
				}
			]);
		},

		sync: function() { return null; },
		fetch: function() { return null; },
		save: function() { return null; }
	});

}(window, APP, Backbone, Marionette, $, _));